import {Component, OnInit} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {OrderService} from "./order.service";
import {handleErrors} from "../misc/handle-errors.decorator";
import {SiteListForOrderGqlModel} from "./order.gql-model";

export interface OrderCreateInputModel {
  projectId?: string;
  siteId?: string;
}

@Component({
  templateUrl: "./order-create-dialog.template.pug",
  providers: [
    OrderService,
  ],
})
export class OrderCreateDialogComponent extends DialogComponent<OrderCreateInputModel, boolean>
  implements OrderCreateInputModel, OnInit {
  projectId: string;
  siteId: string;
  error: Error;
  orderName: string;
  availableSites: SiteListForOrderGqlModel[] = [];

  static show(dialogService: DialogService, projectId: string, siteId: string): Promise<boolean> {
    return dialogService.showDialog(OrderCreateDialogComponent, {projectId, siteId} as OrderCreateInputModel);
  }

  cancel(): void {
    this.result = false;
    this.close();
  }

  @handleErrors()
  async save(): Promise<void> {
    await this.orderService.create(this.orderName, this.siteId);
    this.result = true;
    this.close();
  }

  @handleErrors()
  async loadData(): Promise<void> {
    if (this.siteId) {
      return;
    }

    if (this.projectId) {
      this.availableSites = [];
      const availableSites = await this.orderService.getAvailableSites(this.projectId);

      if (availableSites.length === 1) {
        this.siteId = availableSites[0].id;
        return;
      }

      if (availableSites.length > 1) {
        this.availableSites = availableSites;
        return;
      }
    }

    throw new Error("No sites are available for selection.");
  }

  ngOnInit(): void {
    this.loadData();
  }

  constructor(
    public dialogService: DialogService,
    public orderService: OrderService,
  ) {
    super(dialogService);
  }
}
